/**
 * Stores a key value pair in local storage. Returns the previous value, if there was one.
 * 
 * @param {*} key the key
 * @param {*} value the value
 */
function set(key, value) {
  const previousValue = localStorage.getItem(key);
  localStorage.setItem(key, value);
  return previousValue;
}

/**
 * Gets a value from local storage.
 * 
 * @param {*} key the key
 */
function get(key) {
  return localStorage.getItem(key);
}

/**
 * Checks if a value exists in local storage with a given key.
 * 
 * @param {*} key the key
 */
function exists(key) {
  const current = localStorage.getItem(key);
  return current != null;
}

/**
 * Removes a key/value pair from local storage, if the key is present.
 * 
 * @param {*} the key 
 */
function remove(key) {
  localStorage.removeItem(key);
}

/**
 * Returns the nth key from local storage.
 * 
 * @param {*} n the key index
 */
function getKey(n) {
  return localStorage.key(n);
}

/**
 * Returns all keys from local storage.
 */
function getKeys() {
  return Object.keys(localStorage);
}

/**
 * Stores a key value pair in session storage. Returns the previous value, if there was one.
 *
 * @param {*} key the key
 * @param {*} value the value
 */
function sessionSet(key, value) {
  const previousValue = sessionStorage.getItem(key);
  sessionStorage.setItem(key, value);
  return previousValue;
}

/**
 * Gets a value from session storage.
 *
 * @param {*} key the key
 */
function sessionGet(key) {
  return sessionStorage.getItem(key);
}

/**
 * Checks if a value exists in session storage with a given key.
 *
 * @param {*} key the key
 */
function sessionExists(key) {
  const current = sessionStorage.getItem(key);
  return current != null;
}

/**
 * Removes a key/value pair from session storage, if the key is present.
 *
 * @param {*} key the key
 */
function sessionRemove(key) {
  sessionStorage.removeItem(key);
}

/**
 * Returns the nth key from session storage.
 *
 * @param {*} n the key index
 */
function sessionGetKey(n) {
  return sessionStorage.key(n);
}

/**
 * Returns all keys from session storage.
 */
function sessionGetKeys() {
  return Object.keys(sessionStorage);
}

const Persistence = {
  set,
  get,
  exists,
  remove,
  getKey,
  getKeys,
};

const SessionPersistence = {
  set: sessionSet,
  get: sessionGet,
  exists: sessionExists,
  remove: sessionRemove,
  getKey: sessionGetKey,
  getKeys: sessionGetKeys,
};

export default Persistence;
export { SessionPersistence };
